import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-company-unit-association',
  templateUrl: './company-unit-association.component.html',
  styleUrls: ['./company-unit-association.component.css']
})
export class CompanyUnitAssociationComponent implements OnInit {
  response: any;
  dataSource: any = new MatTableDataSource([]);
  unitDropdownSettings: any = {};
  companies: any = [];
  units: any = [];
  displayedColumns: string[] = ['companies', 'units'];
  filterStatus = true;
  loaderId = 'company-unit-association-loader';
  pagination = {
    pageNo: 1,
    hasNextPage: false,
    hasPrevPage: false,
    totalCompanies: 0,
    totalPages: 0,
    currentRecords: 0
  };
  PAGE_LIMIT = 20;
  timeoutId: any;
  hasUnitsLoaded: boolean = false;
  hasCompaniesLoaded: boolean = false;
  searchCompany: string = '';

  constructor(
    public companyService: CompanyService,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService) {
    this.unitDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    // await this.initUnits();
    // await this.initCompanies();
    if (this.companies.length > 1) {
      this.updatePageCountForFirstPage();
    }
    this.loader.stopLoader(this.loaderId);
  }

  searchCompanies() {
    let filteredCompanies = [];
    if (this.searchCompany.trim().length > 0) {
      this.companies.map(company => {
        if (company.name.toLowerCase().includes(this.searchCompany.toLowerCase()))
          filteredCompanies.push(company);
      }
      );
    }
    else
      filteredCompanies = this.companies;

    this.dataSource = filteredCompanies;
  }

  updatePageCountForFirstPage() {
    console.log("this.pagination.totalCompanies", this.pagination.totalCompanies, this.pagination.currentRecords);
    if (this.pagination.currentRecords < this.pagination.totalCompanies) {
      this.pagination.hasNextPage = true;
      this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.companies.length;
    }
  }

  async goToPreviousPage() {
    this.loader.startLoader(this.loaderId);
    this.pagination.totalCompanies = 0;
    this.pagination.currentRecords = 0;
    if (this.pagination.pageNo > 1) {
      this.pagination.pageNo = this.pagination.pageNo - 1;
      this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.companies.length;
      // await this.initCompanies();
    }
    if (this.pagination.pageNo === 1) {
      this.pagination.hasPrevPage = false;
    }
    this.pagination.hasNextPage = true;
    this.loader.stopLoader(this.loaderId);
  }

  async goToNextPage() {
    this.loader.startLoader(this.loaderId);
    this.pagination.totalCompanies = 0;
    this.pagination.currentRecords = 0;
    this.pagination.pageNo = this.pagination.pageNo + 1;
    this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.companies.length;
    if (this.pagination.currentRecords > this.pagination.totalCompanies) {  //Page count should not exceed total limit
      this.pagination.currentRecords = this.pagination.currentRecords - (this.pagination.currentRecords - this.pagination.totalCompanies);
    }
    // await this.initCompanies();
    if (this.pagination.currentRecords === this.pagination.totalCompanies) {
      this.pagination.hasNextPage = false;
    }
    this.pagination.hasPrevPage = true;
    this.loader.stopLoader(this.loaderId);
  }

  // async initCompanies() {
  //   let response: any = await lastValueFrom(this.companyService.getCompanyUnitsAssociation({ category: 'company', is_active: true }, { name: 1, category: 1 }));
  //   if (response.status == 200) {
  //     this.companies = response.data;
  //     this.dataSource = this.companies;
  //     this.pagination.totalCompanies = this.companies.length;
  //   }
  //   else {
  //     this.toastr.error(response.message, "ERROR");
  //   }
  // }

  // async initUnits() {
  //   let response: any = await lastValueFrom(this.companyService.getCompanyUnitsAssociation({ category: 'unit', is_active: true }, { name: 1, category: 1 }));
  //   if (response.status == 200) {
  //     this.units = response.data;
  //   }
  //   else {
  //     this.toastr.error(response.message, "ERROR");
  //   }
  // }

  // async updateCompanyUnitsAssociation(element) {
  //   let response: any = await lastValueFrom(this.companyService.updateCompanyUnitsAssociation({ _id: element._id }, { $set: { assoc_unit_ids: element.assoc_unit_ids } }));
  //   if (response.status = 200)
  //     this.toastr.success('Relation Updated Successfully!', 'Success');
  //   else
  //     this.toastr.error(response.message, "ERROR");
  // }

  // downloadAsXLSX() {
  //   this.loader.startLoader(this.loaderId);
  //   const filter: any = {
  //     // is_active: this.filterStatus,
  //     source: this.sourceFilter,
  //     // is_deleted: false 
  //   }
  //   if (this.facilityTitleRegExp !== "") {
  //     filter.title = this.facilityTitleRegExp;
  //   }
  //   if (this.companyTitleRegExp !== "") {
  //     filter.companyTitle = this.companyTitleRegExp;
  //   }
  //   this.companyService.exportCompaniesFacilityAssociationAsXLSX(filter).subscribe((response: any) => {
  //     if (response instanceof HttpResponse) {
  //       this.loader.stopLoader(this.loaderId);
  //       var url = window.URL.createObjectURL(response.body);
  //       var a = document.createElement('a');
  //       document.body.appendChild(a);
  //       a.setAttribute('style', 'display: none');
  //       a.href = url;
  //       a.download = `Facility-Company Association`;
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //       a.remove(); // remove the element
  //     }
  //   });
  // }
}
